<!-- 艺术家推荐 -->
<template>
  <div class="newsinfo fd_column">
    <div class="m-b-30">
      <div class="title_mid">
        <img src="@/assets/home/newsinfo.png" alt="" />
        <div @click="toRouterPush('/NewsInfo')" class="more">
          <div>VIEW MORE</div>
          <img src="@/assets/home/arrow-right-up-line.png" alt="" />
        </div>
      </div>
    </div>
    <div class="component_box longhair">
      <div class="inner_box">
        <div class="list_Data">
          <div
            v-if="listData.headImg || listData.newsName || listData.publishDate"
            @click="linkJump(1, '/NewsInfoDetail', { id: listData.id })"
            class="listData_item"
          >
            <div class="left_img">
              <img :src="$baseImgUrl + listData.headImg" alt="" />
            </div>
            <div class="left_content">
              <div class="left_newsName">{{ listData.newsName }}</div>
              <div class="left_time">
                <div>{{ listData.newsCatName }}</div>
                <div>{{ listData.publishDate }}</div>
              </div>
            </div>
          </div>
          <div class="right_flx">
            <div
              class="right_item"
              v-for="item in list"
              :key="item.id"
              @click="linkJump(1, '/NewsInfoDetail', { id: item.id })"
            >
              <img :src="$baseImgUrl + item.headImg" alt="" />
              <div class="right_content">
                <div class="right_newsName">{{ item.newsName }}</div>
                <div class="left_time">
                  <div>{{ item.newsCatName }}</div>
                  <div class="right_time">{{ item.publishDate }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="bg_img" src="@/assets/home/new_bg.png" alt="" />
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { infogetList } from "@/api/Home/Home";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      list: [],
      listData: {},
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    async getList() {
      let postData = { size: 4 };
      const { data } = await infogetList(postData);
      if (data.length > 0) {
        this.listData = data[0];
        this.list = data.slice(1);
      } else {
        this.listData = {};
        this.list = [];
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";
</style>
<style lang="less" scoped>
@media screen and (min-width: 750px) {
  @import "./NewsInfoPC.less";
}
@media screen and (max-width: 750px) {
  @import "./NewsInfoM.less";
}
</style>
